// Utils
export { formatCurrency } from './utils/formatCurrency';
export { formatDate } from './utils/formatDate';
export {
  formatEventDate,
  formatEventDateShort,
  formatEventDateTime,
  formatEventTime,
  getTimeRemaining,
  formatTimeRemaining,
} from './utils/formatEventDate';

export { toSlug, extractIdFromSlug, formatSlugName, toRestaurantSlug } from './utils/slug';

export { isVatTax, excludeVatTaxes } from './utils/vatTaxes';

export { showsTaxList, showsIncludesTaxesAndCharges, showsVatStatement, showsPriceBreakdown } from './utils/taxDisplay';

// Types, hooks, and constants will be added here as they are created
